import { type UseQueryResult, useQuery } from 'react-query';
import { TransactionService } from '../../services/wealthlane-award-services';

const useGetTransactionAwardType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const transactionAwardType = useQuery(
    ['getTransactionAwardType'],
    async () => {
      return await handleRequest(TransactionService.getApiAwardApiAppTransactionAwardTypeList());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionAwardType;
};

export default useGetTransactionAwardType;
